import axios from "axios";

/** No `Authorization: Bearer` — invite/migration/forgot-password must not send a stale session token. */
const axiosWithoutBearer = axios.create();

axios.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem("xsrfToken");
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch {
    // ignore
  }
  return config;
});

export default {
    postUserLogin: (payload, resolve, reject) => {
        axios({
            method: 'post',
            url: `${process.env.REACT_APP_API_URL}user/login`,
            withCredentials: true,
            data: {
                email: payload.email,
                password: payload.password,
                ip: payload.ip,
                browser: payload.browser,
                os: payload.os,
                device: payload.device,
                country: payload.country,
                city: payload.city,
                region: payload.region,
                latitude: payload.latitude,
                longitude: payload.longitude,
                timezone: payload.timezone,
            }
        })
            .then(res => {
                if (res.data.errors)
                    reject(res.data.errors)
                else
                    resolve(res.data)
            })
            .catch(err => {
               reject(err)
            })
    },
    postTokenPwdMail: (payload, resolve, reject) => {
        axios({
            method: 'post',
            url: `${process.env.REACT_APP_API_URL}resend/tokenPasswordMail`,
            data: {
                email: payload.email
            }
        })
            .then(res => {
                resolve(res.data)
            })
            .catch(err => {
               reject(err)
            })
    },
    postTokenPwd: (payload, resolve, reject) => {
        axios({
            method: 'post',
            url: `${process.env.REACT_APP_API_URL}resend/tokenPassword`,
            data: {
                email: payload.email,
                token: payload.token,
            }
        })
            .then(res => {
                resolve(res.data)
            })
            .catch(err => {
                reject(err)
            })
    },
    putPwdUser: (payload, resolve, reject) => {
        axiosWithoutBearer({
            method: 'put',
            url: `${process.env.REACT_APP_API_URL}user/update/password`,
            withCredentials: true,
            data: {
                email: payload.email,
                password: payload.password,
                token_password: payload.token_password,
                isDesktop: payload.isDesktop
            }
        })
            .then(res => {
                resolve(res.data)
            })
            .catch(err => {
                reject(err)
            })
    },
    putPwdUserCompany: (payload, resolve, reject) => {
        axiosWithoutBearer({
            method: 'put',
            url: `${process.env.REACT_APP_API_URL}user/invitation/password`,
            withCredentials: true,
            data: {
                id: payload.id,
                email: payload.email,
                password: payload.password,
                validation: payload.validation
            }
        })
            .then(res => {
                    resolve(res.data)
            })
            .catch(err => {
                if (reject) reject( err)
            })
    },
    putPwdUserTempWorker: (payload, resolve, reject) => {
        axiosWithoutBearer({
            method: 'put',
            url: `${process.env.REACT_APP_API_URL}user/invitation/update-password-migration`,
            withCredentials: true,
            data: {
                id: payload.id,
                email: payload.email,
                password: payload.password,
                validation: payload.validation
            }
        })
            .then(res => {
                resolve(res.data)
            })
            .catch(err => {
                if (reject) reject( err)
            })
    },

    postRoleUser: (payload, resolve, reject) => {
        const headers = {};
        if (payload?.token) {
            headers.Authorization = `Bearer ${payload.token}`;
        }
        axios({
            method: 'post',
            url: `${process.env.REACT_APP_API_URL}user/role`,
            data: payload?.token ? { token: payload.token } : {},
            headers,
        })
            .then(res => {
                    resolve(res.data)
            })
            .catch(err => {
            reject(1, err)
            })
    },
    getUserProfile: (payload, resolve, reject) => {
        axiosWithoutBearer({
            method: 'post',
            url: `${process.env.REACT_APP_API_URL}user/invitation/profile`,
            withCredentials: true,
            data: { refreshToken: payload?.refreshToken }
        })
            .then(res => resolve(res.data))
            .catch(err => reject(err))
    },
    getCities: (payload, resolve, reject) => {
        axios({
            method: 'get',
            url: `${process.env.REACT_APP_API_URL}city`,
            withCredentials: true,
        })
            .then(res => resolve(res.data))
            .catch(err => reject(err))
    },
    // Public page: never send the session token of another account left in the browser.
    getPrivatePoolInvite: (token, resolve, reject) => {
        axiosWithoutBearer({
            method: 'get',
            url: `${process.env.REACT_APP_API_URL}public/privatePool/${encodeURIComponent(token)}`,
        })
            .then(res => resolve(res.data))
            .catch(err => reject(err))
    },
    postPrivatePoolJoin: (payload, resolve, reject) => {
        axiosWithoutBearer({
            method: 'post',
            url: `${process.env.REACT_APP_API_URL}public/privatePool/${encodeURIComponent(payload.token)}/join`,
            data: {
                firstname: payload.firstname,
                lastname: payload.lastname,
                phone: payload.phone,
                email: payload.email || undefined,
                consent: payload.consent,
                // Undefined is dropped by JSON serialization, so the body is unchanged without ?m=.
                memberToken: payload.memberToken || undefined,
            }
        })
            .then(res => resolve(res.data))
            .catch(err => reject(err))
    },
    getAllQualificationsPreferences: (payload, resolve, reject) => {
        axios({
            method: 'get',
            url: `${process.env.REACT_APP_API_URL}qualification/getAllQualificationsPreferences`,
            withCredentials: true,
        })
            .then(res => resolve(res.data))
            .catch(err => reject(err))
    }
}